import { Component, Input, OnInit } from '@angular/core';
import { DescriptionParserService } from 'app/core/services/parse-description.service';
import { Item, Menu, SectionMenu } from '../../models/menu.model';
import { MenuService } from '../../services/menu.service';
import { PreloadImgComponent } from './../../../core/directives/preload-img/preload-img.component';

@Component({
    selector: 'app-item-list',
    templateUrl: './item-list.component.html',
    styleUrls: ['./item-list.component.scss'],
    standalone: false
})
export class ItemListComponent extends PreloadImgComponent implements OnInit {
  /**
   * Informacion del menu seleccionado
   */
  @Input() menu: Menu = {} as Menu;
  /**
   * Listado de productos
   */
  @Input() section: SectionMenu = {} as SectionMenu;
  /**
   * Indica el idioma seleccionado
   */
  language: string | undefined;

  constructor(
    private menuService: MenuService,
    public descriptionParser: DescriptionParserService
  ) {
    super();
  }

  ngOnInit(): void {
    this.menuService.language$.subscribe((lang: string) => {
      this.language = lang;
    });
  }


  clickName(item: Item): void {
    this.menuService.sendAnalyticsInfo(item, this.menu.departament, 'product_click');
  }

}
